var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperplaneleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.58828 9.78047C5.63753 9.91625 5.63753 10.065 5.58828 10.2008L3.16641 17.2875C3.12311 17.4071 3.11736 17.5371 3.14991 17.6601C3.18247 17.7831 3.25178 17.8932 3.3486 17.9758C3.44541 18.0583 3.56511 18.1094 3.6917 18.1221C3.8183 18.1348 3.94575 18.1085 4.05703 18.0469L17.182 10.5398C17.2797 10.4858 17.3612 10.4066 17.4179 10.3104C17.4746 10.2142 17.5045 10.1046 17.5045 9.99297C17.5045 9.88133 17.4746 9.77172 17.4179 9.67555C17.3612 9.57937 17.2797 9.50015 17.182 9.4461L4.05703 1.95781C3.94603 1.89573 3.81871 1.86899 3.69211 1.88117C3.5655 1.89335 3.44562 1.94386 3.34848 2.02597C3.25134 2.10808 3.18157 2.21788 3.14848 2.34069C3.11538 2.4635 3.12055 2.59349 3.16328 2.71328L5.58828 9.78047Z",
    stroke: "#686868",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 10H5.625",
    stroke: "#686868",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplaneleft);
export default __webpack_public_path__ + "static/media/paperplaneleft.d993aa0588eb017cad44cf49a27dbfce.svg";
export { ForwardRef as ReactComponent };